export enum EListingActions {
  SET_REALTORS_ITEMS = 'listing/setRealtorsItems',
  SET_AGENCIES_ITEMS = 'listing/setAgenciesItems',

  SET_REALTORS_LOADING = 'listing/setRealtorsLoading',
  SET_AGENCIES_LOADING = 'listing/setAgenciesLoading',
}
